// extracted by mini-css-extract-plugin
module.exports = {"link":"MenuLink-module--link--2ZYZn","more":"MenuLink-module--more--OMFlz MenuLink-module--link--2ZYZn","badge":"MenuLink-module--badge--21MZL"};